import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import { useDispatch, useSelector } from 'react-redux'
import defaultUserImage from '../assets/images/user4.png'
import { useDeleteChildMutation } from '../redux/api/childApi'
import { setIsGroup, setSelectedUser } from '../redux/slice/userSlice'
import styles from './cssModule/children.module.css'
import swal from 'sweetalert'
import { BsTrashFill } from 'react-icons/bs'
import { MdCreate } from 'react-icons/md'

const ChildInfoCard = ({ child, handleEdit }) => {
  const dispatch = useDispatch()

  const { selectedUser } = useSelector((state) => state.user)
  const { userToken } = useSelector((state) => state.auth)

  const [deleteChild] = useDeleteChildMutation()

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure want to remove this child')) {
      try {
        await deleteChild({ userid: id, person_uid: userToken }).unwrap()
        await swal(
          'Good job!',
          'You deleted this child user successfully!',
          'success'
        )
      } catch (error) {
        console.log(error.message)
      }
    }
  }

  const activeClass = selectedUser?.id === child.user_uid ? 'childActive' : ''

  return (
    <Col md={6} lg={4}>
      <Card
        className={styles.cardContainer + ' ' + activeClass}
        onClick={() => {
          dispatch(setSelectedUser(child))
          dispatch(setIsGroup(false))
        }}
      >
        <div className={'d-flex align-items-center'}>
          <figure className='edit-box'>
            <Card.Img
              variant='top'
              src={child.image || defaultUserImage}
              className='rounded-circle border'
            />
          </figure>
          <Card.Body className='p-0 mx-2'>
            <div className='d-flex align-items-baseline justify-content-between'>
              <h4>{child.username}</h4>
              <div>
                <BsTrashFill
                  className='me-4'
                  style={{ color: '#c36b6b' }}
                  onClick={() => handleDelete(child.user_uid)}
                />
                <MdCreate
                  style={{ color: '#6BC3BA' }}
                  onClick={() => handleEdit(child)}
                />
              </div>
            </div>
            <span>
              {child?.gender[0]?.toUpperCase()} | {child?.age} years old
            </span>
          </Card.Body>
        </div>
      </Card>
    </Col>
  )
}
export default ChildInfoCard
